import {
  createStore,
  compose,
  applyMiddleware,
  combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import demo from '../GBIDemo/reducer';
import user from '../user/reducer';
import userSagas from '../user/sagas';
import notificationSagas from '../notifications/sagas';
import notifications from '../notifications/reducer';
import animalsSaga from '../GBIAnimal/sagas';
import animals from '../GBIAnimal/reducer';
import cow from '../cows/reducer';
import cowFilter from '../cowFilters/reducer';
import nav from '../header/reducer';
import admin from '../admin/reducer';
import pricing from '../admin/pricing/reducer';
import userAdmin from '../admin/userAdmin/reducer';
import orgAdmin from '../admin/orgAdmin/reducer';
import scoreAdmin from '../admin/scoreDefinitions/reducer';
import outletAdmin from '../admin/outlets/reducer';
import whereToBuy from '../wheretobuy/reducer';
import labels from '../admin/labels/reducer';
import helpVidAdmin from '../admin/helpVideos/reducer';
import ultrasound from '../admin/ultrasound/reducer';
import demoSagas from '../GBIDemo/sagas';
import adminSagas from '../admin/sagas';
import userAdminSagas from '../admin/userAdmin/sagas';
import orgAdminSagas from '../admin/orgAdmin/sagas';
import scoreAdminSagas from '../admin/scoreDefinitions/sagas';
import outletAdminSagas from '../admin/outlets/sagas';
import outletSagas from '../wheretobuy/sagas';
import pricingsSagas from '../admin/pricing/sagas';
import cowSagas from '../cows/sagas';
import adminHelpVidSagas from '../admin/helpVideos/saga';
import ultrasoundSagas from '../admin/ultrasound/saga';
import integrationSagas from '../admin/integrations/sagas';

const rootReducer = combineReducers({
  demo,
  user,
  notifications,
  animals,
  cow,
  cowFilter,
  nav,
  admin,
  pricing,
  userAdmin,
  orgAdmin,
  scoreAdmin,
  outletAdmin,
  whereToBuy,
  ultrasound,
  labels,
  helpVidAdmin
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(userSagas);
sagaMiddleware.run(notificationSagas);
sagaMiddleware.run(animalsSaga);
sagaMiddleware.run(demoSagas);
sagaMiddleware.run(adminSagas);
sagaMiddleware.run(userAdminSagas);
sagaMiddleware.run(orgAdminSagas);
sagaMiddleware.run(scoreAdminSagas);
sagaMiddleware.run(outletAdminSagas);
sagaMiddleware.run(outletSagas);
sagaMiddleware.run(pricingsSagas);
sagaMiddleware.run(cowSagas);
sagaMiddleware.run(adminHelpVidSagas);
sagaMiddleware.run(ultrasoundSagas);
sagaMiddleware.run(integrationSagas);

export default store;
